import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalController, ToastController } from '@ionic/angular';
import { ActionsModalComponent } from '../shared/actions-modal/actions-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ErrorToastService {
  public errorSubject = new Subject<number>();

  constructor(
    protected modalCtrl: ModalController,
    private toastController: ToastController
  ) {}

  sendError(errorCode: number) {
    this.errorSubject.next(errorCode);
  }

  async alreadyAcceptedErrorModal() {
    const modal = await this.modalCtrl.create({
      component: ActionsModalComponent,
      breakpoints: [0, 1],
      initialBreakpoint: 1,
      componentProps: {
        data: {
          message:
            'Данная заявка уже принята в работу . Попробуйте принять в работу другую заявку.',
          title: 'Это заявка уже была принята другим экспедитором',
          imageSrc: '../../../assets/images/no-content.svg',
          errorTitle: true
        }
      }
    });
    await modal.present();
  }

  async acceptOrderErrorModal() {
    const modal = await this.modalCtrl.create({
      component: ActionsModalComponent,
      breakpoints: [0, 1],
      initialBreakpoint: 1,
      componentProps: {
        data: {
          message: 'Не удалось принять заявку в работу. Попробуйте позже',
          title: 'Ошибка принятия заявки',
          imageSrc: '../../../assets/images/no-content.svg',
          errorTitle: true
        }
      }
    });
    await modal.present();
  }

  async showSuccess(message: string): Promise<void> {
    await this.showToast(message, 'custom-toast-success');
  }

  async showError(message: string): Promise<void> {
    await this.showToast(message, 'custom-toast-error');
  }

  private async showToast(message: string, cssClass: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'bottom',
      cssClass
    });
    await toast.present();
  }
}
